import gql from 'graphql-tag';

export default gql`
    query($organizationId: String!) {
        crosschainSwapsAmountLimits(organizationId: $organizationId) {
          min,
          max
        }
    }
`;